export default __webpack_public_path__ + "static/media/1. Email Reflection.dc17f31d.wav";